// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type CreateDashboardModalType from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const AsyncCreateDashboardModal = lazyForPaint(
	() => import(/* webpackChunkName: "async-create-dashboard-modal" */ './index'),
	{ ssr: false },
);

const AsyncCreateDashboardModalContainer = (
	props: JSX.LibraryManagedAttributes<
		typeof CreateDashboardModalType,
		ComponentProps<typeof CreateDashboardModalType>
	>,
): React.JSX.Element => (
	<Placeholder name="create-dashboard-modal" fallback={<></>}>
		<AsyncCreateDashboardModal {...props} />
	</Placeholder>
);

export default AsyncCreateDashboardModalContainer;
